import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { styled } from '@mui/material/styles';

const StyledAddBoxIcon = styled(AddBoxIcon)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

type CreateOptionProps = {
  name: string;
  creatableMessage?: string;
};

export const CreateOption = ({ name, creatableMessage }: CreateOptionProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      alignContent="center"
      spacing={2}
      data-testid="multiselect-option"
    >
      <StyledAddBoxIcon />
      <div>
        <Typography variant="text1" color="text.primary">
          {name}{' '}
        </Typography>
        {creatableMessage && (
          <Typography variant="text1" color="text.secondary">
            {creatableMessage}
          </Typography>
        )}
      </div>
    </Stack>
  );
};
